import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { getPaginationUrl } from '../../utils/constants/GetPaginationURL';
import { formatDataForDataTable } from '../../utils/formatData';
const initialState = {
  loading: false,
  subjects: [],
  classes: [],
  availableCourse: [],
  syllabuses: [],
  alltutors: [],
  batches: [],
  coursewisebatches: [],
  trainerassigneddata: [],
  inactiveReasons: [],
  allcourses: [],
  crolist: [],
  cardData: [],
  batchAdmissionRegister: {
    data: [],
    meta: {},
  },
  courses: [],
  batchesAll: [],
  reschedules: [],
  attendanceData: {
    data: [],
    meta: {},
  },
  cardDetails: {},
  calendarData: [],
  modalLoading: false,
  singleDayAttendance: { details: {}, attendance: [] },
  sessionPreferences: [],
  attendanceViewLoading: false,
  studentSubjects: [],
  batchesWithSameCourse: [],
  courseBatches: [],
  smoSmeLeads: [],
  smeList: [],
  addedTopics: [],
  dashBoardCounts: [],
  dashBoardChart: {},
  chartLoading: false,
  tutorPayments: [],
  batchAttendanceTable: [],
  tableLoading: false,
  refundTableDetails: [],
  refTableDetails: [],
  projectCourseBatches: [],
  batchesForAttendance: [],
  batchTopics: [],
  smeTopics: [],
  batchStudents: [],
  attendanceTypes: [],
  offlineCenters: [],
  batchCalenderEdit: {
    tableData: [],
    loading: false,
  },
};

export const getSubjects = createAsyncThunk('batch/get_subject', async () => {
  const res = await apiRequest({
    url: 'pre-data/getSubjects',
    method: 'get',
  });
  return res.data;
});

export const getSyllabus = createAsyncThunk('batch/get_syllabus', async () => {
  const res = await apiRequest({
    url: 'pre-data/getSyllabuses',
    method: 'get',
  });

  return res.data;
});

export const getClasses = createAsyncThunk('batch/get_classes', async () => {
  const res = await apiRequest({
    url: 'pre-data/getClasses',
    method: 'get',
  });

  return res.data;
});

export const getAvailableCourses = createAsyncThunk('batch/getAvailableCourses', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/courses/2?page=1&limit=no`,
  });
  //
  return res;
});

export const addCourseBatch = createAsyncThunk('batch/addCourseBatch', async (data) => {
  const res = await apiRequest({
    url: `batch-management`,
    method: 'post',
    data: data,
  });
  return res;
});

export const updateCourseBatch = createAsyncThunk('batch/updateCourseBatch', async (data) => {
  const res = await apiRequest({
    url: `batch-management/${data.course_batch_id}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getTutorsList = createAsyncThunk('batch/getTutorsList', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/tutor-list?limit=${data.limit}&page=${data.page}&search=${data.search}`,
  });
  //
  return res;
});

export const getBatchesList = createAsyncThunk('batch/getBatchesList', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management?page=${data.page}&limit=${data.limit}&search=${data.search}&course_available_id=${data.course_available_id}&course_batch_status=${data.course_batch_status}`,
  });
  //
  return res;
});

export const changeBatchStatus = createAsyncThunk('batch/changeBatchStatus', async (data) => {
  const res = await apiRequest({
    url: `batch-management/change-status/${data.batchID}`,
    method: 'post',
    data: data,
  });
  return res;
});

export const deleteBatch = createAsyncThunk('batch/deleteBatch', async (ids) => {
  const res = await apiRequest({
    method: 'delete',
    url: `batch-management`,
    data: { ids },
  });
  return res;
});

export const getBatchesUnderCourse = createAsyncThunk('batch/getBatchesUnderCourse', async (courseID) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-available-batches/${courseID}`,
  });
  //
  return res;
});

export const assignBatch = createAsyncThunk('batch/assignBatch', async (data) => {
  const res = await apiRequest({
    url: `batch-assignments-management/${data.courseBatchID}`,
    method: 'post',
    data: {
      data: data.courseEnrollID,
    },
  });
  return res;
});

export const getTrainerAssignedData = createAsyncThunk('batch/getTrainerAssignedData', async (batchID) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-trainer-assignment-management/get-trainer-datas/${batchID}`,
  });
  return res;
});

export const getInactiveReasons = createAsyncThunk('batch/getInactiveReasons', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `admission-register/get-unmapped-reasons`,
  });
  return res;
});

export const assignTutor = createAsyncThunk('batch/assignTutor', async (data) => {
  const res = await apiRequest({
    url: `batch-trainer-assignment-management/assign-trainer/${data.subject_enrollment_id}`,
    method: 'post',
    data: { assignments: data.assignments },
  });
  return res;
});

export const changeTutorStatus = createAsyncThunk('batch/changeTutorStatus', async (data) => {
  const res = await apiRequest({
    url: `batch-trainer-assignment-management/change-trainer-status/${data.subject_enrollment_id}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getBatchAdmissionRegister = createAsyncThunk('batch/getBatchAdmissionRegister', async (dispatchParams) => {
  const { paginationData, batchId, courseId, statusId } = dispatchParams;
  const paginationUrl = getPaginationUrl(paginationData);
  const res = await apiRequest({
    method: 'get',
    url: `/batch-assignments-management${paginationUrl}&course_batch_id=${batchId}&status=${statusId}&course=${courseId}`,
  });
  return res;
});

export const getAllAvailableCourseForBatches = createAsyncThunk(
  'batch/getAllAvailableCourseForBatches',
  async (dispatchParams) => {
    const res = await apiRequest({
      method: 'get',
      url: `/batch-management/get-available-courses?batch_availability=1`,
    });
    return res;
  },
);

export const getAllBatchNameNoPagination = createAsyncThunk(
  'batch/getAllBatchNameNoPagination',
  async ({ isAllBatchesNeeded }) => {
    const res = await apiRequest({
      method: 'get',
      url: `/batch-management/get-all-batches?page=1&limit=no&isAll=${isAllBatchesNeeded == false ? false : true}`,
    });
    return res;
  },
);

export const changeBatchForInduvidualStudent = createAsyncThunk(
  'batch/changeBatchForInduvidualStudent',
  async (data) => {
    const res = await apiRequest({
      url: `/batch-assignments-management/change-user-batch/${data?.batchId}`,
      method: 'post',
      data: data,
    });
    return res;
  },
);

export const courseCertificateIssuing = createAsyncThunk('batch/courseCertificateIssuing', async (data) => {
  const res = await apiRequest({
    url: `/batch-assignments-management/update-course-cerificate/${data.courseEnrollmentId}`,
    method: 'post',
    data: data,
  });
  return res;
});

export const updateAdmissionDataAndTerminationClearance = createAsyncThunk(
  'batch/updateAdmissionDataAndTerminationClearance',
  async (data) => {
    const res = await apiRequest({
      method: 'put',
      url: `/batch-assignments-management/update-termination-clearance-data/${data.course_enrollment_id}`,
      data: data,
    });
    return res;
  },
);

export const getCourseAvailable = createAsyncThunk('batch/getCourseAvailable', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-available-courses?batch_availability=1`,
  });
  return res;
});

export const assignBatchToCro = createAsyncThunk('batch/assignBatchToCro', async (data) => {
  const res = await apiRequest({
    url: `batch-management/assign-to-cro/${data.batchID}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getCROList = createAsyncThunk('batch/getCROList', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `crm-leads/get-cro-list?page=1&limit=no&search=""`,
  });
  return res;
});

export const getCardsData = createAsyncThunk('batch/getCardsData', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-dashboard-data`,
  });
  return res;
});

export const getStudentsUnderBatch = createAsyncThunk('batch/getStudentsUnderBatch', async (data) => {
  const res = await apiRequest({
    url: `batch-assignments-management/get-batch-all-student`,
    method: 'post',
    data: data,
  });
  return res;
});

export const changeBatchBulk = createAsyncThunk('batch/changeBatchBulk', async (data) => {
  const res = await apiRequest({
    url: `batch-assignments-management/change-users-by-batch/${data.newBatchId}`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getRescheduledSession = createAsyncThunk('batch/getRescheduledSession', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-calendar/get-batch-rescheduled-request?reschedule_requested_by=1&page=${data.page}&limit=${data.limit}`,
  });
  return res;
});

export const getAttendenceViewOfCorrespondingStudent = createAsyncThunk(
  'batch/getAttendenceViewOfCorrespondingStudent',
  async (dispatchParams) => {
    const { batchAssignmentId, month, year } = dispatchParams;
    const res = await apiRequest({
      method: 'get',
      url: `/batch-trainer-assignment-management/attendance/${batchAssignmentId}/${year}/${month}`,
    });
    return res;
  },
);
export const getAttendenceViewOfCorrespondingStudentDetails = createAsyncThunk(
  'batch/getAttendenceViewOfCorrespondingStudentDetails',
  async (dispatchParams) => {
    const { batchAssignmentId, month, year } = dispatchParams;
    const res = await apiRequest({
      method: 'get',
      url: `batch-trainer-assignment-management/attendance/cards/${batchAssignmentId}`,
    });
    return res;
  },
);
export const getBatchAcademicCalendar = createAsyncThunk('batch/getBatchAcademicCalendar', async (dispatchParams) => {
  const { batchId, subjectId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `/batch-calendar/get-batch-calendar/${batchId}/${subjectId}`,
  });
  return res;
});

export const getSubjectsUnderBatchId = createAsyncThunk('batch/getSubjectsUnderBatchId', async (batchID) => {
  const res = await apiRequest({
    method: 'get',
    url: `/batch-management/get-enrolled-subjects/${batchID}`,
  });
  return res;
});

export const getSingleDayAttendance = createAsyncThunk('batch/getSingleDayAttendance', async (trainerAttendanceID) => {
  const res = await apiRequest({
    method: 'get',
    url: `/batch-trainer-assignment-management/attendance/batch/${trainerAttendanceID}`,
  });
  return res;
});

export const getStudentSubjects = createAsyncThunk('batch/getStudentSubjects', async (batch_assignment_id) => {
  const res = await apiRequest({
    method: 'get',
    url: `/batch-assignments-management/get-student-subjects/${batch_assignment_id}`,
  });
  return res;
});

export const updateStudentSubjects = createAsyncThunk('batch/updateStudentSubjects', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `batch-assignments-management/update-student-subjects`,
    data: data,
  });
  return res;
});

export const getBatchesWithSameCourseExistNoPagination = createAsyncThunk(
  'batch/getBatchesWithSameCourseExistNoPagination',
  async ({ isAllBatchesNeeded, courseId }) => {
    const res = await apiRequest({
      method: 'get',
      url: `/batch-management/get-all-batches?page=1&limit=no&isAll=${isAllBatchesNeeded == false ? false : true}&course_id=${courseId}`,
    });
    return res;
  },
);
export const getSessionPreferences = createAsyncThunk('batch/getSessionPreferences', async (batchID) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-session-preferences/${batchID}`,
  });
  return res;
});

export const addSessionPreference = createAsyncThunk('batch/addSessionPreference', async (data) => {
  const res = await apiRequest({
    url: `batch-management/add-session-preferences`,
    method: 'post',
    data: data,
  });
  return res;
});

export const updateRestartDate = createAsyncThunk('batch/updateRestartDate', async (data) => {
  const res = await apiRequest({
    url: `batch-management/update-restart-date/${data.batchID}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getAllBatchNameNoPaginationForBulkChange = createAsyncThunk(
  'batch/getAllBatchNameNoPaginationForBulkChange',
  async (data) => {
    const res = await apiRequest({
      method: 'get',
      url: `/batch-management/get-all-batches?page=1&limit=no&isAll=${data.status}&course_id=${data.courseId}`,
    });
    return res;
  },
);

export const getBatchDashboardCounts = createAsyncThunk('batch/getBatchDashboardCounts', async (dispatchParams) => {
  const { projectId, batchId, fromDate, toDate, courseId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/cards/${projectId}/${batchId}/${fromDate}/${toDate}?courseId=${courseId}`,
  });
  return res;
});

export const getBatchDashboardChart = createAsyncThunk('batch/getBatchDashboardChart', async (dispatchParams) => {
  const { projectId, batchId, fromDate, toDate, courseId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/batch-graph/${toDate.split('-')[0]}?courseId=${courseId}&projectId=${projectId}&batchId=${batchId}`,
  });
  return res;
});

export const getTutorPayments = createAsyncThunk('batch/getTutorPayments', async (dispatchParams) => {
  const { projectId, batchId, fromDate, toDate, courseId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/tutor-payments/${fromDate}/${toDate}?courseId=${courseId}&projectId=${projectId}&batchId=${batchId}`,
  });
  return res;
});
export const getBatchAttendance = createAsyncThunk('batch/getBatchAttendance', async (dispatchParams) => {
  const { projectId, batchId, fromDate, toDate, courseId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/batch-attendance/${fromDate}/${toDate}?courseId=${courseId}&projectId=${projectId}&batchId=${batchId}`,
  });
  return res;
});
export const getBatchRefundLists = createAsyncThunk('batch/getBatchRefundLists', async (dispatchParams) => {
  const { projectId, batchId, fromDate, toDate, courseId } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/batch-refund/${fromDate}/${toDate}?courseId=${courseId}&projectId=${projectId}&batchId=${batchId}`,
  });
  return res;
});
export const getRefLeadLists = createAsyncThunk('batch/getRefLeadLists', async (dispatchParams) => {
  const { courseId, projectId, batchId, fromDate, toDate } = dispatchParams;
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/ref-leads?courseId=${courseId}&projectId=${projectId}&batchId=${batchId}`,
  });
  return res;
});
export const changeStudentStatus = createAsyncThunk('batch/changeStudentStatus', async (data) => {
  const res = await apiRequest({
    url: `batch-assignments-management/student-status-change`,
    method: 'post',
    data: data,
  });
  return res;
});

export const assignBatchtoSme = createAsyncThunk('batch/assignBatchtoSme', async (data) => {
  const res = await apiRequest({
    url: `batch-management/assign-to-sme/${data.batchID}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getSmoSmeLeads = createAsyncThunk('batch/getSmoSmeLeads', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-smo-batches?page=${data.page}&limit=${data.limit}&search=${data.search}&course_available_id=${data.course_available_id}&course_batch_status=${data.course_batch_status}`,
  });
  return res;
});

export const getSmeList = createAsyncThunk('crm/getsmelist', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `crm-leads/get-sme-list?page=1&limit=no&search=""`,
  });
  return res;
});

export const getAddedTopics = createAsyncThunk('crm/getAddedTopics', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-calendar/get-batch-schedules?batch_id=${data.batch_id}&page=${data.page}&limit=${data.limit}&search=${data.search}`,
  });
  return res;
});

export const updateStartApproval = createAsyncThunk('batch/updateStartApproval', async (data) => {
  const res = await apiRequest({
    url: `batch-management/update-inactive-permission/${data.batchID}`,
    method: 'put',
    data: data,
  });
  return res;
});

export const getAllProjectsCoursesAndBatches = createAsyncThunk('batch/getAllProjectsCoursesAndBatches', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `/general/get-project-details`,
  });
  return res;
});

export const getBatchesForAttendance = createAsyncThunk('batch/getBatchesForAttendance', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `cro-batch-attendance/get-cro-assigned-batches?page=${data.page}&limit=${data.limit}&search=${data.search}`,
  });
  return res;
});

export const getbatchtopics = createAsyncThunk('batch/getbatchtopics', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-calendar/get-batch-calendar/${data.batch_id}/${data.subject_id}`,
  });
  return res;
});

export const markAttendance = createAsyncThunk('batch/markAttendance', async (data) => {
  const res = await apiRequest({
    url: `cro-batch-attendance/mark-attendance`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getsmeTopics = createAsyncThunk('batch/getsmeTopics', async ({ batchID, subject_enrollment_id }) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-calendar/get-batch-schedules?batch_id=${batchID}&page=1&limit=no&search=&subject_enrollment_id=${subject_enrollment_id}`,
  });
  return res;
});

export const getBatchStudents = createAsyncThunk('batch/getBatchStudents', async ({ batchID }) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-assignments-management?page=1&limit=no&search=&course_batch_id=${batchID}&status=null&course=null`,
  });
  return res;
});

export const getAttendanceTypes = createAsyncThunk('batch/getAttendanceTypes', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cro-batch-attendance/get-attendance-types`,
  });
  return res;
});

export const getOfflineCentersForSKillx = createAsyncThunk('batch/getOfflineCentersForSKillx', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-offline-centers`,
  });
  return res;
});
// -- Batch Calendar Edit
export const getBatchCalendarEdit = createAsyncThunk('batch/getBatchCalendarEdit', async (params) => {
  const searchParams = new URLSearchParams(params);
  const res = await apiRequest({
    method: 'get',
    url: `/batch-calendar/get-batch-calendar-days?${searchParams.toString()}`,
  });
  return res;
});

export const putBatchCalendarEdit = createAsyncThunk('batch/putBatchCalendarEdit', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `batch-calendar/update-batch-calendar-day`,
    data: data,
  });
  return res;
});

export const putBulkBatchCalendarEdit = createAsyncThunk('batch/putBulkBatchCalendarEdit', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `batch-calendar/bulk-update-batch-calendar-day`,
    data: data,
  });
  return res;
});
export const deleteBatchAttendance = createAsyncThunk(
  'batch/deleteBatchAttendance',
  async ({ session_schedule_id, batchId }) => {
    const res = await apiRequest({
      method: 'delete',
      url: `admission-register/delete-attendance?session_schedule_id=${session_schedule_id}&batchId=${batchId}`,
      // data: { session_schedule_id, batchId },
    });
    return res;
  },
);

const batchSlice = createSlice({
  name: 'batch',
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSubjects.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSubjects.fulfilled, (state, action) => {
      return {
        ...state,
        subjects: action.payload.subjects,
        loading: false,
      };
    });
    builder.addCase(getSyllabus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getSyllabus.fulfilled, (state, action) => {
      return {
        ...state,
        syllabuses: action.payload.syllabuses,
        loading: false,
      };
    });
    builder.addCase(getClasses.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getClasses.fulfilled, (state, action) => {
      return {
        ...state,
        classes: action.payload.classes,
        loading: false,
      };
    });
    builder.addCase(getAvailableCourses.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAvailableCourses.fulfilled, (state, action) => {
      return {
        ...state,
        availableCourse: action.payload.data,
        loading: false,
      };
    });
    builder.addCase(updateCourseBatch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCourseBatch.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addCourseBatch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCourseBatch.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------- TUTORS LIST--------------------------------
    builder.addCase(getTutorsList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTutorsList.fulfilled, (state, action) => {
      return {
        ...state,
        alltutors: action.payload.data,
        loading: false,
      };
    });
    // --------------------------------GET BATCHES LIST-------------------------------------
    builder.addCase(getBatchesList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getBatchesList.fulfilled, (state, action) => {
      return {
        ...state,
        batches: action.payload,
        loading: false,
      };
    });
    // --------------- batch status change ------------------------
    builder.addCase(changeBatchStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changeBatchStatus.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------ DL BATCH----------------------------------------
    builder.addCase(deleteBatch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteBatch.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ---------------------------- GET BATCHES BASED ON COURSE-------------------------------
    builder.addCase(getBatchesUnderCourse.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getBatchesUnderCourse.fulfilled, (state, action) => {
      return {
        ...state,
        coursewisebatches: action.payload.data,
        loading: false,
      };
    });
    // --------------------------- ASSIGN BATCH--------------------------------------
    builder.addCase(assignBatch.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignBatch.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ------------------------- GET TRAINER ASSIGNED DATA--------------------------------------
    builder.addCase(getTrainerAssignedData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getTrainerAssignedData.fulfilled, (state, action) => {
      return {
        ...state,
        trainerassigneddata: action.payload.data,
        loading: false,
      };
    });
    // ------------------------ reasons -------------------------------------
    builder.addCase(getInactiveReasons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInactiveReasons.fulfilled, (state, action) => {
      state.loading = false;
      state.inactiveReasons = action.payload?.data || [];
    });
    // ---------------------- ASsign Tutor--------------------------------------------
    builder.addCase(assignTutor.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignTutor.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ---------------------------------- change status ------------------------------------
    builder.addCase(changeTutorStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changeTutorStatus.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ----------------------------- get available course -----------------------------------
    builder.addCase(getCourseAvailable.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCourseAvailable.fulfilled, (state, action) => {
      return {
        ...state,
        allcourses: action.payload.data,
        loading: false,
      };
    });
    // ------------------------- ASSIGN BATCH TO CRO -------------------------------
    builder.addCase(assignBatchToCro.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(assignBatchToCro.fulfilled, (state, action) => {
      state.loading = false;
    });
    // --------------------GET CRO LIST---------------------------------------------------
    builder.addCase(getCROList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCROList.fulfilled, (state, action) => {
      return {
        ...state,
        crolist: action.payload.data,
        loading: false,
      };
    });
    // -----------------------------------get card data --------------------------------------------
    builder.addCase(getCardsData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCardsData.fulfilled, (state, action) => {
      return {
        ...state,
        cardData: action.payload.data,
        loading: false,
      };
    });
    // ---------------------------------- Batch admission Register ------------------------------------
    builder.addCase(getBatchAdmissionRegister.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getBatchAdmissionRegister.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        batchAdmissionRegister: {
          ...state.batchAdmissionRegister,
          data: action?.payload?.data || [],
          meta: action?.payload?.meta || {},
        },
      };
    });
    // ---------------------------------- AVAILABALE COURSES------------------------------------
    builder.addCase(getAllAvailableCourseForBatches.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAllAvailableCourseForBatches.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        courses: action?.payload?.data || [],
      };
    });
    // ---------------------------------- AVAILABALE BATCHES------------------------------------
    builder.addCase(getAllBatchNameNoPagination.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAllBatchNameNoPagination.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        batchesAll: action?.payload?.data || [],
      };
    });
    // ---------------------------------- CHANGE BATCH FOR INDUVIDUAL STUDENT------------------------------------
    builder.addCase(changeBatchForInduvidualStudent.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(changeBatchForInduvidualStudent.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------------------- COURSE CERTIFICATE ISSUING------------------------------------
    builder.addCase(courseCertificateIssuing.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(courseCertificateIssuing.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------------------ADMISSION STATUS CHANGE AND TERMINATION CLEARANCE------------------------------------
    builder.addCase(updateAdmissionDataAndTerminationClearance.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(updateAdmissionDataAndTerminationClearance.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------------------ATTENDANCE VIEW FOR CORRESPONDING STUDENT FROM A BATCH------------------------------------
    builder.addCase(getAttendenceViewOfCorrespondingStudent.pending, (state) => {
      return { ...state, attendanceViewLoading: true };
    });
    builder.addCase(getAttendenceViewOfCorrespondingStudent.fulfilled, (state, action) => {
      return {
        ...state,
        attendanceViewLoading: false,
        attendanceData: {
          ...state.attendanceData,
          data: action?.payload?.data || [],
          meta: action?.payload?.meta || {},
        },
      };
    });
    // ---------------------------------ATTENDANCE VIEW FOR CORRESPONDING STUDENT CARD DETAILS FROM A BATCH------------------------------------
    builder.addCase(getAttendenceViewOfCorrespondingStudentDetails.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAttendenceViewOfCorrespondingStudentDetails.fulfilled, (state, action) => {
      return {
        ...state,

        cardDetails: action?.payload?.data || {},
        loading: false,
      };
    });
    // ---------------------------------GET SUBJECT AGAINST BATCHID------------------------------------
    builder.addCase(getSubjectsUnderBatchId.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getSubjectsUnderBatchId.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        subjects: action?.payload?.data || [],
      };
    });
    // ---------------------------------GET ACADEMIC CALENDOR FOR BATCH------------------------------------
    builder.addCase(getBatchAcademicCalendar.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getBatchAcademicCalendar.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        calendarData: action?.payload?.data || [],
      };
    });
    // --------------------------------GET SINGLE SESSION DAY ATTENDANCE OF STUDENTS------------------------------------
    builder.addCase(getSingleDayAttendance.pending, (state) => {
      return { ...state, modalLoading: true };
    });
    builder.addCase(getSingleDayAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        modalLoading: false,
        singleDayAttendance: {
          ...state.singleDayAttendance,
          details: action?.payload?.data?.details || {},
          attendance: action?.payload?.data?.attendance?.length
            ? formatDataForDataTable(action?.payload?.data?.attendance)
            : [],
        },
      };
    });
    // --------------------------- getting students under batch-------------------------------------
    builder.addCase(getStudentsUnderBatch.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getStudentsUnderBatch.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------------------- change batch by bulk--------------------------------------
    builder.addCase(changeBatchBulk.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(changeBatchBulk.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------- GET RESCHEDULED DATA ------------------------------------------
    builder.addCase(getRescheduledSession.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getRescheduledSession.fulfilled, (state, action) => {
      return {
        ...state,
        reschedules: action.payload,
        loading: false,
      };
    });
    // ------------------------------- GET STUDENT SUBJECT DATA ------------------------------------------
    builder.addCase(getStudentSubjects.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getStudentSubjects.fulfilled, (state, action) => {
      return {
        ...state,
        studentSubjects: action.payload?.data || [],
        loading: false,
      };
    });
    // ------------------------------- UPDATE STUDNET SUBJECT ------------------------------------------
    builder.addCase(updateStudentSubjects.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateStudentSubjects.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------------------- AVAILABALE BATCHES------------------------------------
    builder.addCase(getBatchesWithSameCourseExistNoPagination.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getBatchesWithSameCourseExistNoPagination.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        batchesWithSameCourse: action?.payload?.data || [],
      };
    });
    // ------------------------------- get session Preference-----------------------------------
    builder.addCase(getSessionPreferences.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getSessionPreferences.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        sessionPreferences: action?.payload?.data,
      };
    });
    // -------------------------------- add session Preference-----------------------------------
    builder.addCase(addSessionPreference.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(addSessionPreference.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------------------- update restart date-----------------------------------
    builder.addCase(updateRestartDate.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(updateRestartDate.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------- get batches for bulk change-----------------------------------
    builder.addCase(getAllBatchNameNoPaginationForBulkChange.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAllBatchNameNoPaginationForBulkChange.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        courseBatches: action.payload?.data || [],
      };
    });
    // ----------------------- DASHBOARD COUNTS-----------------------------------
    builder.addCase(getBatchDashboardCounts.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getBatchDashboardCounts.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        dashBoardCounts: action.payload?.data || [],
      };
    });
    // ----------------------- DASHBOARD CHART-----------------------------------
    builder.addCase(getBatchDashboardChart.pending, (state) => {
      return { ...state, chartLoading: true };
    });
    builder.addCase(getBatchDashboardChart.fulfilled, (state, action) => {
      return {
        ...state,
        chartLoading: false,
        dashBoardChart: action.payload?.data || {},
      };
    });
    // ----------------------- DASHBOARD TABLE-----------------------------------
    builder.addCase(getTutorPayments.pending, (state) => {
      return { ...state, tableLoading: true };
    });
    builder.addCase(getTutorPayments.fulfilled, (state, action) => {
      return {
        ...state,
        tableLoading: false,
        tutorPayments: action.payload?.data || [],
      };
    });
    builder.addCase(getBatchAttendance.pending, (state) => {
      return { ...state, tableLoading: true };
    });
    builder.addCase(getBatchAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        tableLoading: false,
        batchAttendanceTable: action.payload?.data || [],
      };
    });
    // ------------------------------------- CHANGE STUDENT STATUS ------------------------------------
    builder.addCase(changeStudentStatus.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(changeStudentStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------------- assign sme ---------------------------------
    builder.addCase(assignBatchtoSme.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(assignBatchtoSme.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------------- get smo sme leads ---------------------------------
    builder.addCase(getSmoSmeLeads.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getSmoSmeLeads.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        smoSmeLeads: action.payload || [],
      };
    });
    // ------------------------------------- get sme list ---------------------------------
    builder.addCase(getSmeList.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getSmeList.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        smeList: action.payload?.data || [],
      };
    });
    // --------------------------------- GET TOPICS --------------------------------------------
    builder.addCase(getAddedTopics.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAddedTopics.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        addedTopics: action.payload || [],
      };
    });
    // ------------------------------- update start approval ---------------------------------------
    builder.addCase(updateStartApproval.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(updateStartApproval.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------------- Get Batch Refund Details ---------------------------------------
    builder.addCase(getBatchRefundLists.pending, (state) => {
      return { ...state, tableLoading: true };
    });
    builder.addCase(getBatchRefundLists.fulfilled, (state, action) => {
      return {
        ...state,
        tableLoading: false,
        refundTableDetails: action.payload?.data || [],
      };
    });
    // ------------------------------- Get Ref leads---------------------------------------
    builder.addCase(getRefLeadLists.pending, (state) => {
      return { ...state, tableLoading: true };
    });
    builder.addCase(getRefLeadLists.fulfilled, (state, action) => {
      return {
        ...state,
        tableLoading: false,
        refTableDetails: action.payload?.data || [],
      };
    });
    // ------------------------------- getAllProjectsCoursesAndBatches---------------------------------------
    builder.addCase(getAllProjectsCoursesAndBatches.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getAllProjectsCoursesAndBatches.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        projectCourseBatches: action.payload?.data || [],
      };
    });
    // ---------------------------- GET BATCHES FOR ATTENDANCE-------------------------------------
    builder.addCase(getBatchesForAttendance.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getBatchesForAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        batchesForAttendance: action.payload || [],
        loading: false,
      };
    });
    // ---------------------------- GET BATCH TOPICS-------------------------------------
    builder.addCase(getbatchtopics.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getbatchtopics.fulfilled, (state, action) => {
      return {
        ...state,
        batchTopics: action.payload?.data || [],
        loading: false,
      };
    });
    // ---------------------------- MARK ATTENDANCE-------------------------------------
    builder.addCase(markAttendance.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(markAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------------- GET SME TOPICS-------------------------------------
    builder.addCase(getsmeTopics.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getsmeTopics.fulfilled, (state, action) => {
      return {
        ...state,
        smeTopics: action.payload?.data || [],
        loading: false,
      };
    });
    // ---------------------------- GET BATCH STUDENTS-------------------------------------
    builder.addCase(getBatchStudents.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getBatchStudents.fulfilled, (state, action) => {
      return {
        ...state,
        batchStudents: action.payload?.data || [],
        loading: false,
      };
    });
    // ---------------------------- GET ATTENDANCE TYPES-------------------------------------
    builder.addCase(getAttendanceTypes.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAttendanceTypes.fulfilled, (state, action) => {
      return {
        ...state,
        attendanceTypes: action.payload?.data || [],
        loading: false,
      };
    });
    // ---------------------------- GET OFFLINE CENTERS FOR SKILLX-------------------------------------
    builder.addCase(getOfflineCentersForSKillx.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getOfflineCentersForSKillx.fulfilled, (state, action) => {
      return {
        ...state,
        offlineCenters: action.payload?.data || [],
        loading: false,
      };
    });
    // ------------------------ Batch Calendaer Edit
    builder.addCase(getBatchCalendarEdit.pending, (state) => {
      state.batchCalenderEdit.loading = true;
    });
    builder.addCase(getBatchCalendarEdit.fulfilled, (state, action) => {
      state.batchCalenderEdit.loading = false;
      state.batchCalenderEdit.tableData = action.payload?.data ?? [];
    });
    // ---------------------- put
    builder.addCase(putBatchCalendarEdit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putBatchCalendarEdit.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ---------------------- put Bulk
    builder.addCase(putBulkBatchCalendarEdit.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putBulkBatchCalendarEdit.fulfilled, (state, action) => {
      state.loading = false;
    });
    // ---------------------------- Delete attendacne-------------------------------------
    builder.addCase(deleteBatchAttendance.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteBatchAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

// export const { apiCallData } = permissionSlice.actions;

export default batchSlice.reducer;
